<tcm-main-frame 
                [isLoading]="isLoading"
                [stretchBodyContentToViewPort]="true">
    <ng-container title>{{title}}</ng-container>
    <div commands>
        <button class="btn btn-complete me-2"
                (click)="download()">{{'Messages.MessageHeadersAndActions.Download' | translate}}</button>
        <button class="btn btn-default"
                (click)="back()">{{'Common.SearchActionsAndDetailsActions.Close' | translate}}</button>
    </div>
    <ng-container body>
        <div #objectContainer style="display: none;"></div>
    </ng-container>
</tcm-main-frame>